/**
 * @file The AbsenceDetailComponent is used as detail view for the inbox and outbox to display exchange requests.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { NotificationsService } from '../notifications.service';
import { DomainService } from '../../domain.service';
import { ExchangeDetailComponent } from '../exchange-detail/exchange-detail.component';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user.service';
import { SettingsService } from '../../settings.service';
/**
 * The AbsenceDetailComponent is used as detail view for the inbox and outbox to display absence requests.
 * @export
 * @class AbsenceDetailComponent
 * @extends {AbstractView}
 */
var AbsenceDetailComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AbsenceDetailComponent, _super);
    /**
     * Constructs a DetailComponent
     * @param configurationsService Service to get the configuration for this component.
     * @param router The angular router enabling navigation between the different form modes.
     * @param route The active route.
     * @param notificationsService The notifications service.
     * @param dialogService The dialog service.
     */
    function AbsenceDetailComponent(userService, router, route, notificationsService, dialogService, alertsService, domainService, settingsService, translateService) {
        var _this = _super.call(this, userService, router, route, notificationsService, dialogService, alertsService, settingsService, translateService) || this;
        _this.domainService = domainService;
        return _this;
    }
    AbsenceDetailComponent.prototype.canSave = function () {
        return this.request != null && this.subjectFormObject && this.subjectFormObject.item != null;
    };
    return AbsenceDetailComponent;
}(ExchangeDetailComponent));
export { AbsenceDetailComponent };
